import { GET } from "../../APiHelper/API"
let source;
export const getStadiums = (onSuccess, onError) => {
    source = GET("/api/v1/leagues/stadiums", onSuccess, onError, true, source)
}